import { render, staticRenderFns } from "./CommodityManage.vue?vue&type=template&id=6103aeb2&scoped=true&"
import script from "./CommodityManage.vue?vue&type=script&lang=js&"
export * from "./CommodityManage.vue?vue&type=script&lang=js&"
import style0 from "./CommodityManage.vue?vue&type=style&index=0&id=6103aeb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6103aeb2",
  null
  
)

export default component.exports